import { Field } from 'formik';
import { InputAdornment } from '@material-ui/core';

import { required } from 'utils/validation.util';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';

import { FluidFormFields as FormFields } from 'utils/fluids/constants.utils';

const PowerLawLiquidFormSection = ({ disabled }) => (
  <>
    <Field
      required
      type="number"
      destroyOnUnmount
      disabled={disabled}
      validate={required}
      label="Flow-Behaviour Index (n)"
      component={TextFieldFormik}
      name={FormFields.FLOW_BEHAVIOUR_INDEX}
    />
    <Field
      required
      type="number"
      destroyOnUnmount
      disabled={disabled}
      validate={required}
      label="Consistency Index (K)"
      component={TextFieldFormik}
      name={FormFields.CONSISTENCY_INDEX}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">lbf-sⁿ/100ft²</InputAdornment>
        ),
      }}
    />
  </>
);

export default PowerLawLiquidFormSection;
